import { combineReducers } from "redux";

import { listReducer } from './listSpools';
import { moveSpoolReducer } from './moveSpools';
import { editReducer } from './editSpools';

const reducer = combineReducers({
    list: listReducer,
    edit: editReducer,
    moveSpool: moveSpoolReducer,
})

export default reducer;